// extracted by mini-css-extract-plugin
export default {"tab":"TabName_tab__szb8R","small":"TabName_small__6M-5D","big":"TabName_big__2bxaG"};